'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Header = exports.DefLoading = exports.DefArrow = exports.Value = undefined;

var _Value = require('./Value');

Object.defineProperty(exports, 'Value', {
  enumerable: true,
  get: function get() {
    return _Value.Value;
  }
});

var _DefArrow = require('./DefArrow');

Object.defineProperty(exports, 'DefArrow', {
  enumerable: true,
  get: function get() {
    return _DefArrow.DefArrow;
  }
});

var _DefLoading = require('./DefLoading');

Object.defineProperty(exports, 'DefLoading', {
  enumerable: true,
  get: function get() {
    return _DefLoading.DefLoading;
  }
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Header = exports.Header = function Header(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      expanded = _ref.expanded,
      focused = _ref.focused,
      selected = _ref.selected,
      nodeRef = _ref.nodeRef,
      onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    {
      className: (0, _utils.classes)('Header', {
        'Header--focusedActive': !disabled && (focused || expanded),
        'Header--expanded': expanded,
        'Header--disabled': disabled,
        'Header--focusedDisabled': disabled && focused,
        'Header--selected': !disabled && focused && selected
      }),
      tabIndex: '0',
      role: 'combobox',
      'aria-expanded': expanded,
      'aria-readonly': 'true',
      'aria-disabled': disabled,
      ref: nodeRef,
      onClick: onClick
    },
    children
  );
};